"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DataStore = _interopRequireDefault(require("../../../KESI2/Stores/DataStore2"));

var _StoreComponent2 = _interopRequireDefault(require("../../../KESI2/Stores/StoreComponent"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DataStoreComponent = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(DataStoreComponent, _StoreComponent);

  var _super = _createSuper(DataStoreComponent);

  function DataStoreComponent(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, DataStoreComponent);
    _this = _super.call(this, props, context);
    _this.dataStorePaths = null; // set in subclass

    return _this;
  }

  (0, _createClass2["default"])(DataStoreComponent, [{
    key: "setDataStorePaths",
    value: function setDataStorePaths(paths) {
      this.dataStorePaths = paths;
      var temp_paths = paths.map(function (path) {
        return "data.".concat(path);
      });
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DataStoreComponent.prototype), "addStoresAndKeys", this).call(this, [{
        store: _DataStore["default"],
        keys: temp_paths
      }]);
    }
  }, {
    key: "mapStoreToState",
    value: function mapStoreToState(changedStore, nextStoreState) {
      if (changedStore !== _DataStore["default"] || !this.dataStorePaths || this.dataStorePaths.length === 0) {
        return null;
      }

      var updateObj = {
        data: _objectSpread({}, this.state.data)
      };
      this.dataStorePaths.forEach(function (path) {
        var fullPath = "data.".concat(path);

        if (fullPath in nextStoreState) {
          updateObj.data[path] = nextStoreState[fullPath];
        }
      });
      return updateObj;
    }
  }]);
  return DataStoreComponent;
}(_StoreComponent2["default"]);

DataStoreComponent.contextTypes = {
  dataStore: _propTypes["default"].object.isRequired
};
var _default = DataStoreComponent;
exports["default"] = _default;